import apiIam from "../config/api_iam";

export function getPlansConfig() {
  return apiIam.get(`/bovexo/auth/plans/config`);
}
